import { type FC, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'

import { Checkbox, FormHelperText } from 'base-ui'

import { MarketplacePartnerRegisterPageCompanyType } from '../../../marketplacePartnerRegisterPageMakeFormState'
import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'

export const MarketplacePartnerRegisterPageFormBasicInformationCompanyType: FC =
  () => {
    const { formState } = useMarketplacePartnerRegisterPageContext()
    formState.use()

    const { model } = formState

    const handleCheckboxChange = useCallback(
      (
        companyType: MarketplacePartnerRegisterPageCompanyType,
        isChecked: boolean,
      ): void => {
        const updatedCompanyTypes = isChecked
          ? [...model.companyType, companyType]
          : model.companyType.filter(
              (company: MarketplacePartnerRegisterPageCompanyType) =>
                companyType !== company,
            )
        formState.setValue(updatedCompanyTypes, model, 'companyType')
      },
      [formState, model],
    )

    return (
      <div className="flex flex-col gap-4">
        <span className="text-l">
          <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.sellerType.title" />
        </span>
        <fieldset className="flex flex-row items-center gap-5">
          <label className="flex items-center gap-2">
            <Checkbox
              checked={model.companyType.includes(
                MarketplacePartnerRegisterPageCompanyType.MANUFACTURER,
              )}
              data-qa-id="sellerForm-checkbox-companyType-manufacturer"
              onChange={(event): void => {
                handleCheckboxChange(
                  MarketplacePartnerRegisterPageCompanyType.MANUFACTURER,
                  event.target.checked,
                )
              }}
            />
            <span>
              <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.sellerType.manufacturer" />
            </span>
          </label>
          <label className="flex items-center gap-2">
            <Checkbox
              checked={model.companyType.includes(
                MarketplacePartnerRegisterPageCompanyType.RETAILER,
              )}
              data-qa-id="sellerForm-checkbox-companyType-retailer"
              onChange={(event): void => {
                handleCheckboxChange(
                  MarketplacePartnerRegisterPageCompanyType.RETAILER,
                  event.target.checked,
                )
              }}
            />
            <span>
              <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.sellerType.retailer" />
            </span>
          </label>
        </fieldset>
        {model.validator.getFirstErrorFor('companyType') && (
          <FormHelperText
            data-qa-id="global-MessageForm-companyType-error-msg"
            error
          >
            {model.validator.getFirstErrorFor('companyType')}
          </FormHelperText>
        )}
      </div>
    )
  }
